// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LyT2_","colBig":"styles_colBig__1hhNw","colSmall":"styles_colSmall__3awdl"};